import { createGlobalStyle } from "styled-components";
import { PUBLIC_URL } from "../../../config";

export const GlobalFormsStyled = createGlobalStyle`
    .form-control {
        font-size: 18px;
        color: var(--color-white);
        background: var(--app-bg-color);
        border: 1px solid var(--app-bg-color);
        box-sizing: border-box;
        border-radius: 8px;
        padding: 0.75rem 1rem;

        &:active,
        &:hover {
            //color: #fff;
            //border: 1px solid var(--color-main);
        }

        &:focus {
            outline: 0;
            color: #fff;
            border-color: var(--app-bg-color);
            background: var(--app-bg-color);
            box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
        }

        &:disabled, &[readonly] {
            background: var(--app-bg-color);
        }

        &:-webkit-autofill,
        &:-webkit-autofill:focus {
            -webkit-text-fill-color: #fff;
            transition: background-color 600000s 0s, color 600000s 0s;
        }
    }

    .form-valid-hint {
        display: none;
        color: #dc3545;
    }

    .form-control:not(:placeholder-shown) {
        &:invalid,
        &.is-invalid {
            + .form-valid-hint {
                display: block;
            }
        }
    }

    .form-control:not(:placeholder-shown):not(:focus):invalid,
    .form-control.is-invalid,
    .was-validated .form-control:invalid {
        background-image: none;
        border-color: #dc3545;
    }

    .form-check {
        min-height: 24px;
        padding-left: 36px;
        display: flex;
        align-items: center;

        label {
            color: #A3A6CC;
            flex: 1;
            margin-left: 16px;
        }
    }

    .form-check .form-check-input {
        margin-left: -36px;
    }

    .form-check .form-check-input {
        width: 24px;
        height: 24px;
        margin-top: 0;
        margin-right: 0;
    }

    .form-check .form-check-input[type=checkbox] {
        border-radius: 8px;
        background-color: transparent;
        border: 1px solid var(--color-yellow);
        color: #0A0A10;

        &:hover {
            border: 1px solid var(--color-yellow);
        }

        &:checked {
            background-color: var(--color-yellow);
            border-color: var(--color-yellow);
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%230A0A10' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");

            &:hover {
                background-color: var(--color-yellow-light);
                border: 1px solid var(--color-yellow-light);
            }
        }
    }

    .app .form-check .form-check-input[type=checkbox] {
        &:hover {
            border: 1px solid var(--icon-primary-color);
        }

        &:checked:hover {
            background-color: var(--color-yellow);
            border: 1px solid var(--color-yellow);
        }
    }

    .form-check-input[type=radio] {
        background-color: transparent;
        border: 1px solid var(--color-main);
        height: 20px;
        width: 20px;
        margin-top: 0;

        &:hover {
            border: 1px solid var(--color-yellow);
        }

        &:checked {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2.8' fill='%23FFDD3C'/%3e%3c/svg%3e");
            border-color: var(--color-yellow);
        }
    }

    .app .form-check-input[type=radio] {
        &:hover {
            border: 1px solid var(--color-main);
        }
    }

    .form-switch {
        .form-check-input[type=checkbox] {
            width: 48px;
            height: 28px;
            margin-top: 0;
            margin-right: 0;
            background-color: var(--color-purple-highlight);
            border: none;
            box-shadow: none;
            background-image: url('${PUBLIC_URL}/assets/icons/switch-circle.svg');
            border-radius: 2em;

            &:checked {
                background-color: var(--color-yellow);
                background-image: url('${PUBLIC_URL}/assets/icons/switch-circle.svg');
            }
        }

        .form-label {
            margin-bottom: 0;
        }
    }

    .form-select {
        font-size: 18px;
        color: var(--color-white);
        background: var(--app-bg-color);
        border: 1px solid var(--app-bg-color);
        background-image: url("${process.env.PUBLIC_URL}/assets/icons/arrow-down.svg");
        background-repeat: no-repeat;
        background-position: right 10px center;
        box-sizing: border-box;
        
        border-radius: 8px;
        padding: 0.75rem 1rem;
        position: relative;
    }

    .input-group {
        .form-control {
            &:focus {
                box-shadow: none;
            }
        }

        .input-group-text {
            border-radius: 16px;
            background: var(--app-bg-color);
            border-color: var(--app-bg-color);
            color: white;
            fill: white;

            .btn {
                border-radius: 12px;
                margin: 0 -4px;
            }
        }
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: var(--color-secondary) !important;
        opacity: 1 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: var(--color-secondary) !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: var(--color-secondary) !important;
    }
`;
